import { Link2Off } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EmptyState = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-gray-200 bg-white py-16 text-center">
      <Link2Off className="size-10 text-gray-400" strokeWidth={1.5} />
      <div className="flex flex-col gap-1">
        <span className="text-base font-semibold text-gray-900">{t('Credentials.EmptyTitle')}</span>
        <span className="text-sm text-gray-500">{t('Credentials.EmptyDescription')}</span>
      </div>
    </div>
  );
};

export default EmptyState;
